import DATA from "../data/_products.json"

import sideImage from "../../assets/images/ices.png"

import "./premium.css"

const Premium = () => {
   return (
      <>
         <h2>&nbsp;Premium Ice Cream Selections</h2>
         <img src={sideImage} alt="ices" className="sideImage"></img>

         <div className="framer">
            {Object.entries(DATA.products).map(
               (p) => {
                  return (
                     <div key={p[0]}>
                        <h3 >{p[0]}</h3>
                        {Object.entries(p[1]).map(
                           (it) => {
                              return (
                                 <span key={it[0]}>
                                    <h2>{it[0]}:&nbsp;</h2>
                                    <ul className="columnar">
                                       {Object.entries(it[1]).map(
                                          (fl) => {
                                             return (
                                                <li key={fl}>
                                                   {fl[1] ? <img src={fl[1]} height="40" alt=""></img> : null}&nbsp;
                                                   {fl[0]}

                                                   {/* if last item */}

                                                   {/* {fl.indexOf === it[1].length - 1 ?
                                                      <br />
                                                      : <> &nbsp;&nbsp;&nbsp;</>
                                                   } */}

                                                </li>
                                             )
                                          })
                                       }
                                    </ul>

                                 </span>
                              )
                           })}
                     </div>
                  )
               })}

         </div>
      </>
   )
}

export default Premium;